@if (
	{
		hasVideo: !!videoId,
	};
	as vm
) {
	<ng-container *clientScreen="let isDesktop = isDesktop">
		<div class="wrapper" [class.desktop]="isDesktop">
			<div class="section">
				<div
					class="image pos-rel"
					[class.cursor-pointer]="vm.hasVideo"
					(click)="vm.hasVideo ? openVideo() : null"
				>
					<ng-content select="img, [img]"></ng-content>
					@if (vm.hasVideo) {
						<div
							class="pos-abs fl p-1 br-circle"
							style="
								top: 50%;
								left: 50%;
								transform: translate(-50%, -50%);
								background-color: rgba(0, 0, 0, 0.5);
							"
						>
							<i class="icon-play-circle fc-white"></i>
						</div>
					}
				</div>
			</div>
			<div class="section" [class.ov-auto]="isDesktop">
				<div class="title">
					<ng-content select="[title]"></ng-content>
				</div>
				<div class="message">
					<ng-content></ng-content>
				</div>
			</div>
		</div>
	</ng-container>
}
